import { CommonModule, DecimalPipe, NgOptimizedImage, isPlatformBrowser } from '@angular/common';
import { Component, Inject, Input, OnInit, PLATFORM_ID, computed, inject } from '@angular/core';
import { Router } from '@angular/router';
import { StarsRateComponent } from '@shared/components/stars-rate/stars-rate.component';
import { ExtractGrade } from '@shared/pipes/extractStarFromClassName.pipe';
import { RialToTomanPipe } from '@shared/pipes/rial-to-toman.pipe';
import { SearchBoxService } from '@shared/services/serach-box.service';
import { SharedModule } from '@shared/shared.module';
import { cdnUrl } from 'apps/ihowebsite/src/app/app.module';

@Component({
 selector: 'iho-hotels-card',
 templateUrl: './hotels-card.component.html',
 styleUrls: ['./hotels-card.component.scss'],
 standalone: true,
 imports: [
  NgOptimizedImage,
  StarsRateComponent,
  ExtractGrade,
  RialToTomanPipe,
  DecimalPipe,
  CommonModule,
  SharedModule,
 ],
})
export class HotelsCardComponent implements OnInit {
 constructor(@Inject(PLATFORM_ID) private platformId: Object) {
  if (isPlatformBrowser(this.platformId)) {
   this.navigatorVal = /Android|iPhone/.test(window.navigator.userAgent);
  }
 }

 @Input({ required: true })
 get dataSource(): any {
  return this._dataSource;
 }
 set dataSource(value: any) {
  this._dataSource = value;
 }
 private _dataSource!: any;
 cdnUrl = cdnUrl;
 @Input() type?: number; // type = 2 will render long-height form of card
 @Input() ecolodgeType?: number; 
 @Input() isAffordableHotels = false;
 router = inject(Router);
 navigatorVal: any;
 searchBoxService = inject(SearchBoxService);
 accommodation = computed(() => this.searchBoxService.accommodation());

 ngOnInit() {}

 navigateToPdp(url: string,ev:Event) {
     ev.preventDefault();
  if (isPlatformBrowser(this.platformId)) {
   this.router.navigate([url], { queryParams: { refer: 'home' } }).finally(() => {
    setTimeout(() => {
     window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 300);
   });
  }
 }
}
